var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4 44c0-4.411 3.589-8 8-8s8 3.589 8 8z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 46h5.651c.222-.626.349-1.298.349-2 0-3.314-2.686-6-6-6s-6 2.686-6 6h6z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13 38.09c-.326-.055-.659-.09-1-.09-3.314 0-6 2.686-6 6h2c0-2.972 2.163-5.433 5-5.91z",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13 36.069c-.328-.041-.661-.069-1-.069-4.411 0-8 3.589-8 8h2c0-4.072 3.06-7.436 7-7.931z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50 42v-2h-21.636l1.636 2z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15 12h-1v-2h1c.552 0 1 .448 1 1 0 .552-.448 1-1 1z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44 44c0-4.411 3.589-8 8-8s8 3.589 8 8z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53 36.069c-.328-.041-.661-.069-1-.069-4.411 0-8 3.589-8 8h2c0-4.072 3.06-7.436 7-7.931z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m52 50c-3.314 0-6-2.686-6-6 0-3.314 2.686-6 6-6 3.314 0 6 2.686 6 6 0 3.314-2.686 6-6 6z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48 44c0-2.972 2.163-5.433 5-5.91-.326-.055-.659-.09-1-.09-3.314 0-6 2.686-6 6s2.686 6 6 6c.341 0 .674-.035 1-.09-2.837-.477-5-2.938-5-5.91z",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 44c0-1.105-.895-2-2-2h-22l-18-22v6l14.799 18.499c.759.949 1.908 1.501 3.123 1.501h22.078c1.105 0 2-.895 2-2z",
    fill: "#3cc8b4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14 26v-3.556l-2-2.444v6l14.799 18.499c.759.949 1.908 1.501 3.123 1.501h2c-1.215 0-2.364-.552-3.123-1.501z",
    fill: "#1eaa96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 8h4v4h-4z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 8h2v4h-2z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 8h-12c-1.105 0-2-.895-2-2 0-1.105.895-2 2-2h12c1.105 0 2 .895 2 2 0 1.105-.895 2-2 2z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6 6c0-1.105.895-2 2-2h-2c-1.105 0-2 .895-2 2s.895 2 2 2h2c-1.105 0-2-.895-2-2z",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 8c1.105 0 2-.895 2-2 0-1.105-.895-2-2-2-1.105 0-2 .895-2 2 0 1.105.895 2 2 2z",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14 18h6v4h-6z",
    fill: "#fa6450"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14 18h2v4h-2z",
    fill: "#dc4632"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17 14c-1.657 0-3 1.343-3 3v1h6v-1c0-1.657-1.343-3-3-3z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 14.184c-.314-.112-.647-.184-1-.184-1.657 0-3 1.343-3 3v1h2v-1c0-1.304.837-2.403 2-2.816z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17 26c1.657 0 3-1.343 3-3v-1h-6v1c0 1.657 1.343 3 3 3z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16 23v-1h-2v1c0 1.657 1.343 3 3 3 .353 0 .686-.072 1-.184-1.163-.413-2-1.512-2-2.816z",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4 46h6v14h-6z",
    fill: "#fa6450"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4 46h2v14h-2z",
    fill: "#dc4632"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 46c1.105 0 2-.895 2-2v-32h-4v32h2z",
    fill: "#3cc8b4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 12h2v32h-2z",
    fill: "#1eaa96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.876 52.141-14.505 1.813c-.247.031-.496.046-.745.046h-5.626c-1.105 0-2-.895-2-2l8.392-1.678c.935-.187 1.608-1.008 1.608-1.962v-.36h-28v8h4l15.964 3.547c1.335.297 2.724.246 4.034-.147l17.289-5.187c.423-.126.713-.515.713-.957v-.123c0-.602-.527-1.067-1.124-.992z",
    fill: "#f0c8a0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 12,
    fill: "#3cc8b4",
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46 12c0-4.079 3.055-7.438 7-7.931-.328-.041-.661-.069-1-.069-4.418 0-8 3.582-8 8s3.582 8 8 8c.339 0 .672-.028 1-.069-3.945-.493-7-3.852-7-7.931z",
    fill: "#1eaa96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57 10-6 6-4-4 2-2 2 2 4-4z",
    fill: "#f0f0f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRental);
export default __webpack_public_path__ + "static/media/logo-rental.ab3fffadb230b5b164b6100d2dab7def.svg";
export { ForwardRef as ReactComponent };